import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const AppFooter = () => {
  const { currentOrg } = useAuth();
  const [versionInfo, setVersionInfo] = useState({
    version: '2.5',
    label: '',
    logoUrl: null
  });

  useEffect(() => {
    const fetchVersionSettings = async () => {
      if (!currentOrg?.id) return;
      try {
        const response = await axios.get(`${API}/api/organizations/${currentOrg.id}/version-settings`);
        if (response.data) {
          setVersionInfo({
            version: response.data.version || '2.5',
            label: response.data.label || '',
            logoUrl: response.data.logo_url || null
          });
        }
      } catch (error) {
        // Use defaults if not set
        console.log('Using default version settings');
      }
    };
    fetchVersionSettings();
  }, [currentOrg?.id]);

  return (
    <footer className="fixed bottom-0 left-0 right-0 z-40 bg-background/80 backdrop-blur-sm border-t border-border/50 py-2 px-4">
      <div className="max-w-screen-2xl mx-auto flex items-center justify-end gap-3">
        {/* Logo */}
        {versionInfo.logoUrl ? (
          <img 
            src={versionInfo.logoUrl.startsWith('http') ? versionInfo.logoUrl : `${API}${versionInfo.logoUrl}`} 
            alt="Logo" 
            className="h-6 w-auto object-contain"
          />
        ) : (
          <div className="flex items-center gap-1.5">
            <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-emerald-400 to-teal-500 flex items-center justify-center">
              <span className="text-white text-xs font-bold">K</span>
            </div>
          </div>
        )}
        
        {/* Version Badge */}
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-foreground">Ocean Fishing Bissau</span>
          <span className="text-xs px-2 py-0.5 rounded-full bg-muted text-muted-foreground font-medium">
            v{versionInfo.version}
            {versionInfo.label && (
              <span className="ml-1 text-emerald-500">{versionInfo.label}</span>
            )}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
